import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SSBIImpulseEmotional',
    label: 'SSBIImpulseEmotional',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
